var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoShareSixt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "10px",
    viewBox: "0 0 23 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B6575F34-4E5E-43DC-AEC4-7E1AA70C49D9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.78391643,7.9786147 C6.40602488,7.9786147 7.02672787,8.83180243 7.06100096,10.2328496 L4.51116401,10.2328496 C4.4941206,9.85675898 4.37286093,9.56294541 4.19506929,9.42664431 C4.02330028,9.29487408 3.87434895,9.23383728 3.61292353,9.23851244 C3.06638576,9.24858423 2.77605795,9.46427646 2.77605795,9.81228724 C2.77605795,9.91563135 2.81014477,10.0472284 2.8870419,10.1224927 C3.28850889,10.5455946 6.14127771,10.8465941 6.96128614,11.6551369 C7.09142453,11.7831555 7.22410857,11.9502203 7.31801807,12.1821024 L7.31801807,10.6183194 C8.16512832,10.6474958 9.04672897,10.6215516 9.91494946,10.4953511 L9.91476319,14.3920676 L12.026718,11.4763843 L11.0361202,10.2701354 C11.8636725,10.0578774 12.6151037,9.72946189 13.2701108,9.25273993 L13.9080435,10.0040265 L15.1188707,8.30339398 L22,8.30339398 L22,10.233571 L20.4525577,10.233571 L20.4525577,14.9463914 L15.1188707,14.9463914 L13.7539077,13.0507875 L12.3350826,14.9463914 L7.31801807,14.9463914 L7.31801807,13.6503045 C6.95740559,14.5668666 5.81900514,15.1249998 3.5617933,15.1249998 C0.213585904,15.1249998 0.0512854524,14.024779 0,12.7647081 L2.64784431,12.7647081 C2.65638154,13.1407987 2.72474145,13.4135741 2.8870419,13.5921536 C3.05784853,13.7709352 3.28850889,13.8649289 3.6301532,13.8649289 C4.16815374,13.8649289 4.74899564,13.7239527 4.74899564,13.1784309 C4.74899564,13.0561841 4.70637159,12.95284 4.63801169,12.8682254 C4.28786119,12.4357731 1.34096557,12.1160442 0.512419902,11.3166785 C0.179312817,10.9969207 0.0768660897,10.517486 0.0768660897,10.131843 C0.0768660897,8.64618129 1.31538493,7.9786147 3.78391643,7.9786147 Z M17.878693,10.2387947 L16.6101541,10.2387947 L15.6417842,11.5033675 L17.878693,14.5461748 L17.878693,10.2387947 Z M14.6604561,6.875 C13.8485813,9.05723175 11.3171226,10.4244273 7.31744713,10.2373632 L7.31744713,8.30340555 C9.96162824,8.4845247 11.4499929,7.78884941 11.9606744,6.875 L14.6604561,6.875 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Sixtbook_dashboard-share-content",
    transform: "translate(-658.000000, -835.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "center",
    transform: "translate(430.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdonw",
    transform: "translate(208.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/16x16/ico_sixt_16",
    transform: "translate(20.386200, 116.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoShareSixt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_share_sixt.364baebca16b97243603343927591d71.svg";